import { getPatientPortalSystemId as getHostNameSystemId } from 'utils/get-pp-system-id/hostname-system-id';
import { getPatientPortalSystemId as getLocalStorageSystemId } from 'utils/get-pp-system-id/local-storage-system-id';
import { isPatientPortalDeveloperMode } from 'common/env';
import { PATIENT_PORTAL_SYSTEM_IDS } from 'types/patient-portal-system.types';

// Hook to resolve the Patient Portal System ID
export function usePPSystemId() {
  const defaultSystemId = PATIENT_PORTAL_SYSTEM_IDS.AMPLAR;
  const localStorageSystemId = getLocalStorageSystemId();
  const hostnameSystemId = getHostNameSystemId();

  if (isPatientPortalDeveloperMode() && localStorageSystemId) {
    return localStorageSystemId;
  }

  if (hostnameSystemId) return hostnameSystemId;

  return defaultSystemId;
}
